/* eslint-disable no-underscore-dangle */
import PouchDB from 'pouchdb';
import _ from 'lodash';
import { get } from '../utils/api';
import { upsert } from './common';
import endpoints from '../endpoints';

const CUSTOMER_PRICE_GROUPS = 'XXSCustomerPriceGroup';

class CustomerPriceGroupsStore {
  constructor(name) {
    this.db = new PouchDB(name);
  }

  save = (response, onSuccess) => {
    upsert(this.db, CUSTOMER_PRICE_GROUPS, _.invert(response.data), onSuccess);
  };

  fetchAndSave = (onSuccess) => get(endpoints.customerPriceGroups.get).then((response) => this.save(response, onSuccess));

  load = (callback) => {
    this.db
      .get(CUSTOMER_PRICE_GROUPS)
      .then((doc) => {
        callback(doc);
      })
      .then(() => {})
      .catch(() => {
        callback();
      });
  };
}

export default CustomerPriceGroupsStore;
